import moment from "moment";



export function formatDateTime(date: string) {
    if (!date || date === '') {
        return ''
    }

    const localDate = new Date(moment(date).local().valueOf())

    let localDateString = localDate.toString()
    if (localDateString.indexOf("GMT") > 0) {
        localDateString = localDateString.substring(0, localDateString.indexOf("GMT"))
    }

    return localDateString
}

// convert UTC time to PST time
export function convertUtcToPst(utcTime: string) {
    if (!utcTime || utcTime === '') return '';

    // convert utc to loacal time object
    const localDate = new Date(utcTime);

    // Get the time zone offset in minutes for the local date object relative to UTC
    const utcOffsetMinutes = localDate.getTimezoneOffset();

    // Convert UTC time string to PST time string.
    const pstDate = new Date(localDate.getTime() - utcOffsetMinutes * 60000 - 8 * 3600000);
    return pstDate.toUTCString().replaceAll('GMT', 'PST');
}



export function SubtractUtcTimes(utcTime1:string){


  // 将 UTC 时间字符串转换为 Date 对象
  let date1 = new Date(utcTime1);
  let date3 = new Date();
  

  // 相减得到时间差（以毫秒为单位）
  const timeDiff = getUTCTime() - date1.getTime();

  console.log('timeDiff',getUTCTime())
  console.log('timeDiff',utcTime1)
  console.log('timeDiff',date1.getTime())
  console.log('timeDiff',timeDiff)

  // 将时间差转换为以分钟为单位
  const minutesDiff = Math.floor(timeDiff / 1000 / 60);

    return minutesDiff;
};

function getUTCTime(){ 
    var date = new Date();
    return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(), 
        date.getUTCSeconds()
    ).getTime(); 
  }

const fillZero = (time: number) => {
    return String(time).padStart(2, '0');
}
/**
 * format date to mm/dd/yyyy
 * @param date 
 * @returns 
 */
export function formatDateToMMDDYYYY(date?: Date){
  return date ? `${fillZero(date.getMonth()+1)}/${fillZero(date.getDate())}/${date.getFullYear()}` : '' 
};

export function validateInputText(text: string) {
    if(!text || text.trim() === '' || text.length > 200) {
        return false
    }
    return true
}

export function validateReplaceText(text: string) {
    return /^.{3,100}$/.test(text)
}

/**
 * check the url address is correct
 */
export function checkURLFormatIsCorrect(urlString: string) {
    if(urlString.trim() === '') {
        return true
    }
    const regex1 = /^(https?:\/\/(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]*\.)+[a-zA-Z]+)(:\d+)?(\/.*)?$/
    const regex2 = /^(ftp|file):\/\/|mailto:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex1.test(urlString.trim()) || regex2.test(urlString.trim())
}

export function validateKBID(value: string) {
    return /^\d{4,12}$/.test(value)
}

/**
 * check UUID format
 * @param value 
 * @returns 
 */
export function validateGUID(value: string) {
    return /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/i.test(value)
}

/**
 * format date to yyyy-mm-ddThh:mm:ss.msZ
 * @param date 
 * @returns 
 */
export function formatDateToUTCStringDate(date?: Date): string {
    return date? `${date.getUTCFullYear()}-${fillZero(date.getUTCMonth() + 1)}-${fillZero(date.getUTCDate())}T${fillZero(date.getUTCHours())}:${fillZero(date.getUTCMinutes())}:${fillZero(date.getUTCSeconds())}.${fillZero(date.getUTCMilliseconds())}Z`: "";
}













